<template>
  <v-app>
    <component :is="layout" />

    <helper-maintenance-mode :show-dialog="maintenanceDialog" />
    <!-- <helper-add-phone
      v-if="phoneDialog"
      :show-dialog="phoneDialog"
      :mandatory="true"
      @closePhoneDialog="closePhoneDialog"
    /> -->
    <helper-version-dialog
      :show-dialog="versionDialog"
      :version="appState"
    />
    <!-- <plan-wizard 
      v-if="planWizardDialog"
      :show-dialog="planWizardDialog"
      @closePlanWizardDialog="closePlanWizardDialog"
    /> -->

    <helper-notification />
  </v-app>
</template>
<script>
const APP_STATE_QUERY = require("@/graphql/queries/AppState.gql");

import { mapMutations, mapState, mapGetters } from "vuex";
import { Quill } from "vue2-editor";
import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register("modules/imageResize", ImageResize);


export default {
  data: () => ({
    // phoneDialog: false,
    // planWizardDialog: false,
    maintenanceDialog: false,
    versionDialog: false,
  }),
  metaInfo() {
    return {
      title: this.$ls.get("config").name,
    };
  },
  computed: {
    ...mapState("app", ["version"]),
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("app", ["getIsLoggedIn"]),
    layout() {
      if (this.$route.name !== null) {
        return "core-" + this.$route.meta.layout;
      }
      return null;
    },
  },
  mounted() {
    this.setVersion(require("../package.json").version);
    this.$moment.locale(this.$i18n.locale);
    localStorage.setItem("page_reloaded", false);

    const isLoggedIn =
      localStorage.getItem("auth-token") != null ? true : false;
    this.setIsLoggedIn(isLoggedIn);
    this.fixAutoFills();
  },
  methods: {
    ...mapMutations("app", ["setVersion", "setAppState", "setIsLoggedIn"]),
    fixAutoFills() {
      setTimeout(() => {
        const els = document.querySelectorAll("input:-webkit-autofill");
        els.forEach((el) => {
          const label = el.parentElement.querySelector("label");
          label.classList.add("v-label--active");
        });
      }, 1000);
    },
  },
  apollo: {
    appState: {
      query: APP_STATE_QUERY,
      variables: {
        app_name: "aum-expert-admin",
      },
      fetchPolicy: "network",
      pollInterval: 30 * 1000,
      result({ loading, data: { appState } }) {
        if (!loading && appState != undefined) {
          this.setAppState(appState);
          // if (this.version !== appState.version) {
          //   this.versionDialog = true;
          // }
          if (appState.status !== "live") {
            this.maintenanceDialog = true;
          } else {
            this.maintenanceDialog = false;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
</style>
